define.alias("shared/components/shared/configurable-address-fields", "calendar/components/shared/configurable-address-fields");